import React, { useEffect } from "react";
import { Box, Typography, TextField, Autocomplete, FormControl, Select, MenuItem, Alert } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchContactProfileFields } from "../../redux/Slice/Settings/contactProfileFieldsSlice";
import { CORE_CONTACT_FIELD_OPTIONS, DEFAULT_CONTACT_FIELDS_VALUE } from "./contactFieldsBranch";

/**
 * Config UI for the "Branch: Contact Fields" action: pick built-in contact fields and/or
 * custom Contact Profile fields, and whether all or any of them must have a value.
 */
const ContactFieldsEditor = ({ value, onChange, workspaceId, error, selectMenuProps, selectSx }) => {
  const dispatch = useDispatch();
  const profileFields = useSelector((state) => state.contactProfileFields?.items) || [];

  useEffect(() => {
    if (workspaceId) dispatch(fetchContactProfileFields(workspaceId));
  }, [workspaceId, dispatch]);

  const current = value ?? DEFAULT_CONTACT_FIELDS_VALUE;
  const selectedIds = Array.isArray(current.fieldIds) ? current.fieldIds : [];
  const fieldOptions = [...CORE_CONTACT_FIELD_OPTIONS, ...profileFields];
  const update = (patch) => onChange({ ...current, ...patch });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
      <Typography variant="body2" color="text.secondary">
        Splits the workflow: the YES path runs when the contact has a value for the fields below, the NO path runs otherwise.
      </Typography>
      <Autocomplete
        multiple
        size="small"
        options={fieldOptions}
        getOptionLabel={(f) => f.name || ""}
        isOptionEqualToValue={(a, b) => a._id === b._id}
        value={fieldOptions.filter((f) => selectedIds.includes(f._id))}
        onChange={(_, selected) => update({ fieldIds: selected.map((f) => f._id) })}
        renderInput={(params) => <TextField {...params} label="Contact fields" placeholder="Select fields" />}
      />
      <FormControl size="small">
        <Select
          value={current.matchMode === "any" ? "any" : "all"}
          onChange={(e) => update({ matchMode: e.target.value })}
          MenuProps={selectMenuProps}
          sx={selectSx}
        >
          <MenuItem value="all">YES when all selected fields have a value</MenuItem>
          <MenuItem value="any">YES when any selected field has a value</MenuItem>
        </Select>
      </FormControl>
      {error && <Alert severity="error">{error}</Alert>}
    </Box>
  );
};

export default ContactFieldsEditor;
